import { useEffect } from 'react';
import { autoScroller } from '@atlaskit/pragmatic-drag-and-drop-react-beautiful-dnd-autoscroll';
import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

/**
 * VISIBLE FOR TESTING
 */
export const monitor: Parameters<typeof monitorForElements>[0] = {
	onDragStart: ({ location }) => {
		autoScroller.start({ input: location.current.input });
	},
	onDrop: () => {
		autoScroller.stop();
	},
	onDrag: ({ location }) => {
		autoScroller.updateInput({
			input: location.current.input,
		});
	},
};

/**
 * pragmatic-dnd implements auto scroll behavior so that when the mouse reaches
 * the edges of the scroll container it's scrolled automatically.
 *
 * This works transparently and this hook sets it up.
 */
export function useAutoScroller() {
	useEffect(() => monitorForElements(monitor), []);
}
